import { render, staticRenderFns } from "./attachmentView.vue?vue&type=template&id=faf07cee&scoped=true"
import script from "./attachmentView.vue?vue&type=script&lang=js"
export * from "./attachmentView.vue?vue&type=script&lang=js"
import style0 from "./attachmentView.vue?vue&type=style&index=0&id=faf07cee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf07cee",
  null
  
)

export default component.exports